module.exports = __webpack_public_path__ + "img/plus-circle.6ffa59fc.svg";